module.exports = __webpack_public_path__ + "media/images/defaultreleases-9099cba3.png";